// extracted by mini-css-extract-plugin
export default {"bioContainer":"Biodiversity_bioContainer__GpdYi","bioText":"Biodiversity_bioText__uXf+3","bio":"Biodiversity_bio__MSReP"};